import React from 'react';
import { Card, CardBody } from '../components/ui/Card';
import { Heart, Shield, Users, Award } from 'lucide-react';
export function About() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-145">
      {/* Hero */}
      <div className="relative bg-warm-900 text-white py-24 lg:py-32 overflow-hidden" data-id="element-146">
        <div className="absolute inset-0" data-id="element-147">
          <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Transportation fleet" className="w-full h-full object-cover" data-id="element-148" />
          <div className="absolute inset-0 bg-warm-900/75" data-id="element-149"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-150">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-151">
            Driven by Compassion.
          </h1>
          <p className="text-xl text-warm-200 max-w-3xl mx-auto" data-id="element-152">
            We believe that mobility is a fundamental right, and getting to your
            destination safely should never be a source of stress.
          </p>
        </div>
      </div>

      {/* Our Story */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-153">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-154">
          <div className="lg:w-1/2" data-id="element-155">
            <h2 className="text-3xl font-bold text-warm-900 mb-6" data-id="element-156">Our Story</h2>
            <div className="space-y-4 text-lg text-warm-600" data-id="element-157">
              <p data-id="element-158">
                AccessRide was founded in 2015 after our founder, Sarah Jenkins,
                struggled to find reliable transportation for her father who
                required a wheelchair and regular dialysis treatments.
              </p>
              <p data-id="element-159">
                She quickly realized that standard taxi services lacked the
                necessary equipment, and many medical transport companies lacked
                the compassion and punctuality required for vulnerable patients.
              </p>
              <p data-id="element-160">
                What started with a single modified van and a commitment to
                treating every passenger like family has grown into a fleet of
                modern, accessible vehicles serving thousands of residents,
                hospitals, and senior communities across the metropolitan area.
              </p>
              <p className="font-medium text-primary-700" data-id="element-161">
                Our mission remains unchanged: To provide safe, reliable, and
                dignified transportation that empowers independence and improves
                health outcomes.
              </p>
            </div>
          </div>
          <div className="lg:w-1/2" data-id="element-162">
            <div className="grid grid-cols-2 gap-4" data-id="element-163">
              <img src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Driver helping passenger" className="rounded-xl shadow-md w-full h-64 object-cover" data-id="element-164" />
              <img src="https://images.unsplash.com/photo-1559416523-140ddc3d238c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Wheelchair accessible van" className="rounded-xl shadow-md w-full h-64 object-cover mt-8" data-id="element-165" />
            </div>
          </div>
        </div>
      </div>

      {/* Core Values */}
      <div className="bg-warm-50 py-20" data-id="element-166">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
          <div className="text-center mb-16" data-id="element-168">
            <h2 className="text-3xl font-bold text-warm-900 mb-4" data-id="element-169">
              Our Core Values
            </h2>
            <p className="text-lg text-warm-600 max-w-2xl mx-auto" data-id="element-170">
              These principles guide every decision we make and every ride we
              provide.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-171">
            <Card className="border-none shadow-md text-center" data-id="element-172">
              <CardBody className="p-8" data-id="element-173">
                <Heart className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-174" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-175">
                  Compassion
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-176">
                  We treat every passenger with the dignity, respect, and
                  patience we would want for our own family members.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md text-center" data-id="element-177">
              <CardBody className="p-8" data-id="element-178">
                <Shield className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-179" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-180">
                  Safety First
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-181">
                  From rigorous vehicle maintenance to extensive driver
                  training, safety is never compromised.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md text-center" data-id="element-182">
              <CardBody className="p-8" data-id="element-183">
                <Award className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-184" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-185">
                  Reliability
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-186">
                  We understand that medical appointments are critical. We show
                  up on time, every time.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md text-center" data-id="element-187">
              <CardBody className="p-8" data-id="element-188">
                <Users className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-189" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-190">
                  Community
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-191">
                  We are proud partners in our local healthcare ecosystem,
                  actively supporting disability advocacy.
                </p>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>

      {/* The Team */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <h2 className="text-3xl font-bold text-warm-900 mb-4" data-id="element-194">
            The People Behind the Wheel
          </h2>
          <p className="text-lg text-warm-600 max-w-2xl mx-auto" data-id="element-195">
            Our drivers are the heart of AccessRide. They aren't just drivers;
            they are trained care professionals.
          </p>
        </div>

        <div className="bg-primary-900 rounded-3xl overflow-hidden shadow-2xl flex flex-col lg:flex-row" data-id="element-196">
          <div className="lg:w-1/2 p-12 lg:p-16 flex flex-col justify-center text-white" data-id="element-197">
            <h3 className="text-2xl font-bold mb-6" data-id="element-198">
              Rigorous Training Standards
            </h3>
            <ul className="space-y-4" data-id="element-199">
              <li className="flex items-start" data-id="element-200">
                <Shield className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-201" />
                <span data-id="element-202">
                  Comprehensive background checks and regular drug screening
                </span>
              </li>
              <li className="flex items-start" data-id="element-203">
                <Heart className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-204" />
                <span data-id="element-205">CPR, First Aid, and Defensive Driving Certification</span>
              </li>
              <li className="flex items-start" data-id="element-206">
                <Users className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-207" />
                <span data-id="element-208">
                  PASS (Passenger Assistance Safety and Sensitivity) Certified
                </span>
              </li>
              <li className="flex items-start" data-id="element-209">
                <Award className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-210" />
                <span data-id="element-211">
                  Specialized training in wheelchair securement and lift
                  operation
                </span>
              </li>
            </ul>
          </div>
          <div className="lg:w-1/2" data-id="element-212">
            <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Professional driver smiling" className="w-full h-full object-cover min-h-[400px]" data-id="element-213" />
          </div>
        </div>
      </div>
    </div>;
}